<template>
  <div>

<b-container class="side-n"  >
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('whoweare')" block squared id="bwhoweare" class=" btn-color btn-color-active">
        Who We Are
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('regoffice')" block squared id="bregoffice" class=" btn-color ">
        Registered Office
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('profile')" block squared id="bprofile" class=" btn-color">
        Company Profile
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row" >
    <b-col>
      <b-button @click="goto('glance')" block squared id="bglance" class=" btn-color">
      APDCL at a Glance
      </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('Mandate')" block squared id="bMandate" class=" btn-color">
    Mandate of the company</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button  @click="goto('vision')" block squared id="bvision" class=" btn-color">
      Our Vision</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('mission')" block squared id="bmission" class=" btn-color">
      Our Mission</b-button></b-col>
  </b-row>
  <!--<b-row class="custom-row">
    <b-col ><b-button @click="goto('minister')" block squared id="bminister" class=" btn-color">
    Minister</b-button></b-col>
  </b-row>-->
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('bod')" block squared id="bbod" class=" btn-color">
    Board of Directors</b-button></b-col>
  </b-row>

  <!-- <b-row class="custom-row">
    <b-col ><b-button @click="goto('chairmsg')" block squared id="bchairmsg" class=" btn-color">
      Chairman's Message</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('mdmsg')" block squared id="bmdmsg" class=" btn-color">
      MD's Message</b-button></b-col>
  </b-row> -->

<!-- <b-row class="custom-row">
    <b-col ><b-button @click="goto('kofficial')" block squared id="bkofficial" class=" btn-color">
    Key Officials</b-button></b-col>
  </b-row> -->
  <!-- <b-row class="custom-row" style="  height:60px;">
    <b-col ><b-button @click="goto('jobchart')" block squared id="bjobchart" class=" btn-color" >
    Job Chart and Responsibilities of<br> Key Officials</b-button></b-col>
  </b-row> -->
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('adminh')" block squared id="badminh" class=" btn-color">
    Administration Hierarchy</b-button></b-col>
  </b-row>
  <!-- <b-row class="custom-row">
    <b-col ><b-button @click="goto('scaleop')" block squared id="bscaleop" class=" btn-color">
    Scale of Operations</b-button></b-col>
  </b-row> -->
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('gmap')" block squared id="bgmap" class=" btn-color">
  Geographical Map  </b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col ><b-button @click="goto('pmap')" block squared id="bpmap" class=" btn-color">
    Power Map</b-button></b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col>
      <a  href="https://www.apdcl.org/website/docs/about/ISO_Certificate.pdf" target="_blank">
      <b-button block squared id="" class=" btn-color">
    ISO Certificate</b-button>
  </a>
</b-col>
  </b-row>
  <b-row class="custom-row">
    <b-col >
      <a  href="https://www.apdcl.org/website/docs/about/Quality_Policy.pdf" target="_blank">
    <b-button  block squared variant="" class=" btn-color">
    Quality Policy</b-button>
</a>
  </b-col>
  </b-row>
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
  goto(refName) {
     var element=document.getElementById(refName);
     var btn_id='b' + refName;
     var btn=document.getElementById(btn_id);
     element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });
     document.querySelector(".btn-color-active").classList.remove("btn-color-active");
     btn.classList.add("btn-color-active");
     // document.getElementsByClassName("btn-color-active").classList.remove("btn-color-active");
   }
  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;

 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd       ;
  border-color: #0277bd       ;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1     ;
  border-color: #0288d1     ;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}

</style>
